import React from 'react';
import { Badge, type BadgeProps } from '@companycam/slab-web';
import { translate } from 'translations/i18n';

export type UpgradeBadgeProps = {
  size?: BadgeProps['size'];
  style?: React.CSSProperties;
};

const UpgradeBadge = ({ style, size = 'medium' }: UpgradeBadgeProps) => {
  return (
    <Badge iconName="lightning-bolt" size={size} color="upgrade" style={style}>
      {translate('upgradeBadge.label')}
    </Badge>
  );
};

export default UpgradeBadge;
